// Mock data for Template 5 interior design website
export const mockRootProps = {
  businessInfo: {
    name: "VISIBEEN",
    logo: "/images/visibeen-logo.png",
    heroTitle: "welcome to the future of home",
    heroSubtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    ctaText: "Book Request",
    heroBackgroundImage: "/images/interior-hero.jpg",
    phoneNumber: "+1 386-688-3295"
  },
  navigation: {
    menuItems: ["Home", "About Us", "Services", "Contact", "Blogs"]
  },
  aboutUs: {
    sectionLabel: "about us",
    title: "We see what you can't",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
    image: "/images/interior-about.png",
    features: [
      {
        id: 1,
        title: "House for Everyone",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
        icon: "/images/house-icon.png"
      },
      {
        id: 2,
        title: "Competitive Price",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
        icon: "/images/price-icon.png"
      },
      {
        id: 3,
        title: "Long-Term Investment",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
        icon: "/images/investment-icon.png"
      }
    ]
  },
  services: [
    {
      id: 1,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-1.png"
    },
    {
      id: 2,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-2.png"
    },
    {
      id: 3,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-2.png"
    },
    {
      id: 4,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.sed do eiusmod tempor.",
      image: "/images/interior-service-4.jpg"
    },
    {
      id: 5,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-1.png"
    },
    {
      id: 6,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-2.png"
    },
    {
      id: 7,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-service-2.png"
    },
    {
      id: 8,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.sed do eiusmod tempor.",
      image: "/images/interior-service-4.jpg"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Thomas",
      role: "Manager",
      review: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud",
      avatar: "/images/testimonial-thomas.png",
      rating: 5
    },
    {
      id: 2,
      name: "Cherry bol",
      role: "Manager",
      review: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud",
      avatar: "/images/testimonial-cherry.png",
      rating: 5
    }
  ],
  blogs: [
    {
      id: 1,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-blog-1.svg",
      ctaText: "Learn more"
    },
    {
      id: 2,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
      image: "/images/interior-blog-2.svg",
      ctaText: "Learn more"
    },
    {
      id: 3,
      title: "Lorem Ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.sed do eiusmod tempor.",
      image: "/images/interior-blog-3.svg",
      ctaText: "Learn more"
    }
  ],
  faq: [
    {
      id: 1,
      question: "What is the first step in the home buying process?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      isExpanded: true
    },
    {
      id: 2,
      question: "How long does it take to buy a home?",
      answer: null,
      isExpanded: false
    },
    {
      id: 3,
      question: "What is an escrow account?",
      answer: null,
      isExpanded: false
    },
    {
      id: 4,
      question: "What is a contingency in a real estate contract?",
      answer: null,
      isExpanded: false
    }
  ],
  contactInfo: {
    address: "Plaza X , XY Floor, XYZ Street, XYZ",
    email: "yourname@email.com",
    phone: "+123-456-7890",
    hours: {
      weekdays: "Mon-Fri: 9 AM – 6 PM",
      saturday: "Saturday: 9 AM – 4 PM",
      sunday: "Sunday: Closed"
    }
  },
  footer: {
    logo: "/images/visibeen-logo.png",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,.",
    newsletter: {
      title: "newsletter subscribe",
      placeholder: "Enter your Email",
      buttonText: "submit"
    },
    socialMedia: {
      facebook: "#",
      twitter: "#",
      whatsapp: "#",
      linkedin: "#"
    },
    copyright: {
      text: "Copyright © 2025 visibeen. All Rights Reserved.",
      links: "Privacy Policy Terms & Conditions"
    }
  },
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "Plaza X , XY Floor, XYZ Street, XYZ"
  }
};